export const TOGGLE_DOCSIS_CHANNELS = 'TOGGLE_DOCSIS_CHANNELS';

export const setDocsisChannels = docsisChannels => ({
  type: TOGGLE_DOCSIS_CHANNELS,
  value: {docsisChannels},
});
